import { memo, type ReactNode } from "react";
import { Flex } from "../flex";
import { SettingsRowLabel } from "./settings-row-label";
import * as css from "./settings-rows.module.css";

/** Narrow control in the 196px column. A switch belongs on SettingsToggleRow. */
export const SettingsControlRow = memo(function SettingsControlRow({
  title,
  description,
  controlWidth = "standard",
  children,
}: {
  title: string;
  description?: string;
  controlWidth?: "standard" | "content";
  children: ReactNode;
}) {
  return (
    <Flex
      align="center"
      gap="3xl"
      justify="space-between"
      px="2xl"
      py="xl"
      w="full"
    >
      <SettingsRowLabel description={description} title={title} />
      <Flex
        align="flex-end"
        className={controlWidth === "standard" ? css.controlColumn : undefined}
        dir="column"
        gap="none"
        shrink={0}
      >
        {children}
      </Flex>
    </Flex>
  );
});
